import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(horoscope)/horoscope/numerology/NumerologyClient.tsx");
